"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("hsplit", styles.root, className),
        splitter: styling_1.mergeStyles("hsplit-splitter", styles.splitter),
        splitterHandle: styling_1.mergeStyles("hsplit-splitter-handle", styles.splitterHandle),
        leftPane: styling_1.mergeStyles("hsplit-left-pane", styles.leftPane),
        leftContent: styling_1.mergeStyles("hsplit-left-content", styles.leftContent),
        rightPane: styling_1.mergeStyles("hsplit-right-pane", styles.rightPane),
        rightContent: styling_1.mergeStyles("hsplit-right-content", styles.rightContent)
    };
});
exports.getClassNames = getClassNames;
